/* eslint-disable react/no-danger */
/* eslint-disable no-unused-vars */
import { Helmet } from 'react-helmet-async';
import useAuth from '../../hooks/useAuth';
import { Autocomplete, Backdrop, Box, Button, Card, CircularProgress, Container, Paper, Table, TableBody, TableCell, TableHead, TablePagination, TableRow, TextField, Typography, Breadcrumbs, Link, Grid, InputAdornment, Chip, Avatar } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme, withStyles } from '@mui/styles';
import {
  FilterList as FilterListIcon,
  Refresh as RefreshIcon,
  Sort as SortIcon,
  Person as PersonIcon,
  Category as CategoryIcon,
  Label as LabelIcon,
  Notifications as NotificationsIcon,
  Assignment as CampaignIcon,
  Event as EventIcon,
  School as SchoolIcon,
  Computer as FormationIcon,
  ReportProblemOutlined as QualityIcon,
  PeopleAltOutlined as PartnerIcon,
  WorkOutline as PrestationIcon,
  CalendarToday as CalendarIcon,
  Search as CustomerIcon
} from '@material-ui/icons';
import * as moment from 'moment';
import useMounted from '../../hooks/useMounted';
import { useState, useCallback, useEffect } from 'react';
import Scrollbar from '../../components/Scrollbar';
import { logApi } from '../../api/logApi';
import Label from '../../components/Label';
import useSettings from '../../hooks/useSettings';
import ArrowLeftIcon from '../../icons/ArrowLeft';
import FeedIcon from '@mui/icons-material/Feed';
import ChevronRightIcon from '../../icons/ChevronRight';
import { motion, AnimatePresence } from 'framer-motion';

const CATEGORY_STYLES = {
  utilisateur: { label: 'Utilisateur', color: '#10b981', bg: 'rgba(16, 185, 129, 0.1)', icon: <PersonIcon fontSize="small" /> },
  Qualité: { label: 'Qualité', color: '#ef4444', bg: 'rgba(239, 68, 68, 0.1)', icon: <QualityIcon fontSize="small" /> },
  notification: { label: 'Notification', color: '#ef4444', bg: 'rgba(239, 68, 68, 0.1)', icon: <NotificationsIcon fontSize="small" /> },
  apprenant: { label: 'Apprenant', color: '#f59e0b', bg: 'rgba(245, 158, 11, 0.1)', icon: <SchoolIcon fontSize="small" /> },
  campagne: { label: 'Campagne', color: '#8b5cf6', bg: 'rgba(139, 92, 246, 0.1)', icon: <CampaignIcon fontSize="small" /> },
  session: { label: 'Session', color: '#3b82f6', bg: 'rgba(59, 130, 246, 0.1)', icon: <EventIcon fontSize="small" /> },
  formation: { label: 'Formation', color: '#0ea5e9', bg: 'rgba(14, 165, 233, 0.1)', icon: <FormationIcon fontSize="small" /> },
  partenaires: { label: 'Partenaires', color: '#0d9488', bg: 'rgba(20, 184, 166, 0.1)', icon: <PartnerIcon fontSize="small" /> },
  prestations: { label: 'Prestations', color: '#ec4899', bg: 'rgba(236, 72, 153, 0.1)', icon: <PrestationIcon fontSize="small" /> },
};

const AnimatedMeshBackground = () => (
    <Box sx={{ 
        position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, 
        overflow: 'hidden', zIndex: 0, opacity: 0.4,
        background: '#F8FAFC',
        pointerEvents: 'none'
    }}>
        <motion.div
            animate={{ x: [0, 120, -60, 0], y: [0, -120, 60, 0], scale: [1, 1.3, 0.8, 1] }}
            transition={{ duration: 30, repeat: Infinity, ease: "linear" }}
            style={{ position: 'absolute', top: '-15%', left: '-10%', width: '45vw', height: '45vw', background: 'radial-gradient(circle, rgba(59,130,246,0.12) 0%, rgba(255,255,255,0) 70%)', borderRadius: '50%', filter: 'blur(60px)' }}
        />
        <motion.div
            animate={{ x: [0, -100, 80, 0], y: [0, 100, -50, 0], scale: [1, 1.2, 0.9, 1] }}
            transition={{ duration: 35, repeat: Infinity, ease: "linear" }}
            style={{ position: 'absolute', bottom: '-25%', right: '-10%', width: '55vw', height: '55vw', background: 'radial-gradient(circle, rgba(16,185,129,0.1) 0%, rgba(255,255,255,0) 70%)', borderRadius: '50%', filter: 'blur(60px)' }}
        />
    </Box>
);

const sortOptions = [
  {
    label: 'Plus récent',
    value: 'created_at|desc'
  },
  {
    label: 'Plus ancien',
    value: 'created_at|asc'
  },
];

const Logs = () => {
  // const { settings } = useSettings();
  const { user } = useAuth();
  const theme = useTheme();
  const mounted = useMounted();
  const { settings } = useSettings();
  const [logs, setLogs] = useState([]);
  const [logsInfos, setLogsInfos] = useState({ categories: [], types: [], users: [], customers: [] });
  // const [filteredLogs, setFilteredLogs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [numberLogs, setNumberLogs] = useState(0);
  const [limit, setLimit] = useState(25);
  // const [isSearching, setIsSearching] = useState(false);
  const [sort, setSort] = useState('created_at|desc');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [userSyna, setUserSyna] = useState('all');
  const [category, setCategory] = useState('all');
  const [type, setType] = useState('all');
  const [customer, setCustomer] = useState('all');
  const [customerAutocomplete, setCustomerAutocomplete] = useState({ value: 'all', label: 'Tous' });
  const [choiceCustomer, setChoiceCustomer] = useState('');
  const [usersOptions, setUsersOptions] = useState([]);
  const [categoriesOptions, setCategoriesOptions] = useState([]);
  const [typesOptions, setTypesOptions] = useState([]);
  const [customersOptions, setCustomersOptions] = useState([]);

  useEffect(() => {
    const usersOptionsTemp = logsInfos.users.map((userInfo) => ({ value: userInfo.userId, label: `${userInfo.firstname} ${userInfo.lastname}` }));
    usersOptionsTemp.unshift({
      value: 'all',
      label: 'Tous'
    });
    setUsersOptions(usersOptionsTemp);

    const categoriesOptionsTemp = logsInfos.categories.map((categoryInfo) => ({ value: categoryInfo.category, label: categoryInfo.category.charAt(0).toUpperCase() + categoryInfo.category.slice(1) }));
    categoriesOptionsTemp.unshift({
      value: 'all',
      label: 'Tous'
    });
    setCategoriesOptions(categoriesOptionsTemp);

    const typesOptionsTemp = logsInfos.types.map((typeInfo) => ({ value: typeInfo.type, label: typeInfo.type.charAt(0).toUpperCase() + typeInfo.type.slice(1) }));
    typesOptionsTemp.unshift({
      value: 'all',
      label: 'Tous'
    });
    setTypesOptions(typesOptionsTemp);

    const customersOptionsTemp = logsInfos.customers.map((customerInfo) => ({ value: customerInfo.id, label: `${customerInfo.firstname} ${customerInfo.lastname}` }));
    customersOptionsTemp.unshift({
      value: 'all',
      label: 'Tous'
    });
    setCustomersOptions(customersOptionsTemp);
  }, [logsInfos]);

  const handleValuesFilters = (async (userChange, categoryChange, typeChange, customerChange, startDateChange, endDateChange) => {
    try {
      // si le spinner de la page n'est pas actif (loading), on déclenche le spinner de la table des apprenants au chargement des données
      setIsLoading(true);
      // setIsSearching(true);
      const data = await logApi.getValuesFilters(window.localStorage.getItem('accessToken'), userChange, categoryChange, typeChange,
        customerChange, startDateChange, endDateChange);
      // setNumberLogs(data.numberLogs.numberLogs);
      // setLogs(data.logs);
      // setUsersOptions(data.users);
      const usersOptionsTemp = data.users.map((userInfo) => ({ value: userInfo.userId, label: `${userInfo.firstname} ${userInfo.lastname}` }));
      usersOptionsTemp.unshift({
        value: 'all',
        label: 'Tous'
      });
      setUsersOptions(usersOptionsTemp);
      const categoriesOptionsTemp = data.categories.map((categoryInfo) => ({ value: categoryInfo.category, label: categoryInfo.category.charAt(0).toUpperCase() + categoryInfo.category.slice(1) }));
      categoriesOptionsTemp.unshift({
        value: 'all',
        label: 'Tous'
      });
      setCategoriesOptions(categoriesOptionsTemp);

      const typesOptionsTemp = data.types.map((typeInfo) => ({ value: typeInfo.type, label: typeInfo.type.charAt(0).toUpperCase() + typeInfo.type.slice(1) }));
      typesOptionsTemp.unshift({
        value: 'all',
        label: 'Tous'
      });
      setTypesOptions(typesOptionsTemp);

      const customersOptionsTemp = data.customers.map((customerInfo) => ({ value: customerInfo.id, label: `${customerInfo.firstname} ${customerInfo.lastname}` }));
      customersOptionsTemp.unshift({
        value: 'all',
        label: 'Tous'
      });
      setCustomersOptions(customersOptionsTemp);
      setIsLoading(false);
    } catch (err) {
      console.error(err);
    }
  });

  useEffect(() => {
    handleValuesFilters(userSyna, category, type, customer, startDate, endDate);
  }, [userSyna, category, type, customer, startDate, endDate]);

  const getLogs = useCallback(async () => {
    try {
      const data = await logApi.getAllLogs(sort, userSyna, category, type, customer,
        limit, page, localStorage.getItem('accessToken'));
      const dataInfos = await logApi.getLogsInfos(localStorage.getItem('accessToken'));
      if (mounted.current) {
        setLogs(data.logs);
        setLogsInfos(dataInfos);
        setNumberLogs(data.numberLogs.numberLogs);
        setIsLoading(false);
      }
    } catch (err) {
      console.error(err);
    }
  }, [mounted]);

  useEffect(() => {
    getLogs();
  }, [getLogs]);
  // pour afficher le loader uniquement dans le tableau
  const StyledPaper = withStyles({
    root: {
      position: 'relative'
    }
  })(Paper);
  const LimitedBackdrop = withStyles({
    root: {
      position: 'absolute',
      zIndex: 1
    }
  })(Backdrop);

  const handleLogs = (async (sortChange, startDateChange, endDateChange, userChange, categoryChange, typeChange, customerChange, limitChoice, pageChoice, displaySpinnerTable = false) => {
    try {
      // si le spinner de la page n'est pas actif (loading), on déclenche le spinner de la table des apprenants au chargement des données
      if (!isLoading && displaySpinnerTable) {
        setIsLoading(true);
      }
      // setIsSearching(true);
      const data = await logApi.getLogs(window.localStorage.getItem('accessToken'), sortChange, startDateChange, endDateChange, userChange, categoryChange, typeChange,
        customerChange, limitChoice, pageChoice);
      setNumberLogs(data.numberLogs.numberLogs);
      setLogs(data.logs);
      // setOptionsSearch(data.customers);
      setIsLoading(false);
      // setIsSearching(false);
      // setLoadingAutocomplete(false);
    } catch (err) {
      console.error(err);
    }
  });

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    handleLogs(sort, startDate, endDate, userSyna, category, type, customer, limit, newPage, true);
  };
  const handleLimitChange = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);// handleLogs(query, sort, currentSource, currentCampaign, callTrack, currentNewCallTrack, currentCallTrackRelance, avancement, currentEndSessions, relance, filters, parseInt(event.target.value, 10), 0, modeRelance, true, true);
    handleLogs(sort, startDate, endDate, userSyna, category, type, customer, event.target.value, 0, true);
  };

  const handleSortChange = (event, value) => {
    if (typeof event.target === 'undefined') {
      setSort(value);
    } else {
      setSort(event.target.value);
      // window.localStorage.setItem('choiceSort', JSON.stringify(event.target.value));
    }
    setPage(0);
    handleLogs(event.target.value, startDate, endDate, userSyna, category, type, customer, limit, 0, true);
  };

  const handleStartDateChange = (event, value) => {
    if (event.target.value !== '') {
      setStartDate(moment(new Date(event.target.value)).format('YYYY-MM-DD'));
    } else {
      setStartDate('');
    }
    setPage(0);
    handleLogs(sort, moment(new Date(event.target.value)).format('YYYY-MM-DD'), endDate, userSyna, category, type, customer, limit, 0, true);
  };

  const handleEndDateChange = (event, value) => {
    if (event.target.value !== '') {
      setEndDate(moment(new Date(event.target.value)).format('YYYY-MM-DD'));
    } else {
      setEndDate('');
    }
    setPage(0);
    handleLogs(sort, startDate, moment(new Date(event.target.value)).format('YYYY-MM-DD'), userSyna, category, type, customer, limit, 0, true);
  };

  const handleUserChange = (event, value) => {
    if (typeof event.target === 'undefined') {
      setUserSyna(value);
    } else {
      setUserSyna(event.target.value);
      // window.localStorage.setItem('choiceSort', JSON.stringify(event.target.value));
    }
    setPage(0);
    handleLogs(sort, startDate, endDate, event.target.value, category, type, customer, limit, 0, true);
  };

  const handleCategoryChange = (event, value) => {
    if (typeof event.target === 'undefined') {
      setCategory(value);
    } else {
      setCategory(event.target.value);
      // window.localStorage.setItem('choiceSort', JSON.stringify(event.target.value));
    }
    setPage(0);
    handleLogs(sort, startDate, endDate, userSyna, event.target.value, type, customer, limit, 0, true);
  };

  const handleTypeChange = (event, value) => {
    if (typeof event.target === 'undefined') {
      setType(value);
    } else {
      setType(event.target.value);
      // window.localStorage.setItem('choiceSort', JSON.stringify(event.target.value));
    }
    setPage(0);
    handleLogs(sort, startDate, endDate, userSyna, category, event.target.value, customer, limit, 0, true);
  };

  const handleCustomerChange = (event, value) => {
    if (typeof event.target === 'undefined') {
      setCustomer(value);
    } else {
      setCustomer(event.target.value);
      // window.localStorage.setItem('choiceSort', JSON.stringify(event.target.value));
    }
    setPage(0);
    handleLogs(sort, startDate, endDate, userSyna, category, type, event.target.value, limit, 0, true);
  };

  const reinitializeFilters = () => {
    // on met à jour le localstorage
    // window.localStorage.setItem('choiceTabProfession', JSON.stringify('all'));
    // window.localStorage.setItem('choiceRelance', JSON.stringify('all'));
    // window.localStorage.setItem('choiceCampaign', JSON.stringify('all'));
    // window.localStorage.setItem('choiceCallTrackRelance', JSON.stringify('all'));
    // window.localStorage.setItem('choiceNewCallTrack', JSON.stringify('all'));
    // window.localStorage.setItem('choiceCallTrack', JSON.stringify('all'));
    // window.localStorage.setItem('choiceAvancement', JSON.stringify('all'));
    // window.localStorage.setItem('choiceEndSession', JSON.stringify('all'));
    // window.localStorage.setItem('choiceSource', JSON.stringify('all'));
    // on réinitialise les filtres
    setSort('created_at|desc');
    setStartDate('');
    setEndDate('');
    setType('all');
    setCategory('all');
    setUserSyna('all');
    setCustomer('all');
    setCustomerAutocomplete({ value: 'all', label: 'Tous' });
    setPage(0);
    // // on affiche les résultats réinitialisés
    handleLogs('created_at|desc', '', '', 'all', 'all', 'all', 'all', limit, page, true);
  };
  return (
    <>
      <Helmet>
        <title>Dashboard: Activités | Syndays</title>
      </Helmet>
      <Box
        sx={{
          bgcolor: '#F8FAFC',
          minHeight: '100%',
          position: 'relative',
          overflow: 'hidden',
          pb: 10,
          pt: 4
        }}
      >
        <AnimatedMeshBackground />

        <Container maxWidth={settings.compact ? 'xl' : false} sx={{ position: 'relative', zIndex: 1 }}>
          {user.access_level === 0 && (
          <>
            <Box sx={{ mb: 2 }}>
              <Button
                component={RouterLink}
                to="/dashboard"
                startIcon={<ArrowLeftIcon style={{ fontSize: 14 }} />}
                size="small"
                sx={{
                  color: '#64748B',
                  fontWeight: 800,
                  textTransform: 'none',
                  bgcolor: 'rgba(0,0,0,0.03)',
                  borderRadius: '10px',
                  px: 2,
                  '&:hover': { bgcolor: 'rgba(0,0,0,0.06)' }
                }}
              >
                Retour
              </Button>
            </Box>

            <Grid container spacing={3} sx={{ mb: 4 }}>
              <Grid item xs={12}>
                <Box sx={{ 
                    p: 3, borderRadius: '24px', 
                    background: 'rgba(255,255,255,0.8)', backdropFilter: 'blur(10px)', border: '1px solid rgba(255,255,255,0.9)',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.03)',
                    display: 'flex', alignItems: 'center', gap: 3
                }}>
                  <Box
                    sx={{
                      width: 56,
                      height: 56,
                      borderRadius: '16px',
                      background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      boxShadow: '0 8px 20px rgba(59, 130, 246, 0.3)',
                      flexShrink: 0,
                    }}
                  >
                    <FeedIcon sx={{ color: '#fff', fontSize: '1.7rem' }} />
                  </Box>
                  <Box>
                    <Breadcrumbs separator={<ChevronRightIcon fontSize="small" />} sx={{ mb: 1 }}>
                        <Link color="textPrimary" component={RouterLink} to="/dashboard" variant="caption" sx={{ fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', textDecoration: 'none', '&:hover': { color: '#3b82f6' } }}>Dashboard</Link>
                        <Typography color="textSecondary" variant="caption" sx={{ fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em' }}>Paramètres</Typography>
                    </Breadcrumbs>
                    <Typography variant="h4" sx={{ fontWeight: 900, color: '#0F172A', letterSpacing: '-0.02em', mb: 0.5 }}>
                        Activités
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#64748B', fontWeight: 500 }}>
                        Consultez le journal des actions utilisateurs et des événements système.
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>

            <Box
              sx={{
                mt: 2
              }}
            >
              <Card
                sx={{
                  borderRadius: '20px',
                  overflow: 'hidden',
                  border: '1px solid #e2e8f0',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                  background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                }}
              >
                <Box sx={{ p: 3, bgcolor: 'rgba(255, 255, 255, 0.7)', backdropFilter: 'blur(10px)', borderBottom: '1px solid #e2e8f0' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
                    <FilterListIcon sx={{ color: 'primary.main' }} />
                    <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b' }}>Filtres de recherche</Typography>
                  </Box>
                  <Box
                    sx={{
                      alignItems: 'center',
                      display: 'flex',
                      flexWrap: 'wrap',
                      m: -1,
                    }}
                  >
                    <Box
                      sx={{
                        m: 1
                      }}
                    >
                      <TextField
                        key="sort"
                        label="Trier par date"
                        name="sort"
                        onChange={handleSortChange}
                        select
                        SelectProps={{ native: true }}
                        value={sort}
                        variant="outlined"
                        disabled={isLoading}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SortIcon color="action" />
                            </InputAdornment>
                          ),
                          sx: { borderRadius: '12px', bgcolor: 'white' }
                        }}
                      >
                        {sortOptions.map((option) => (
                          <option
                            key={option.value}
                            value={option.value}
                          >
                            {option.label}
                          </option>
                        ))}
                      </TextField>
                    </Box>
                    <Box
                      sx={{
                        m: 1
                      }}
                    >
                      <TextField
                        // error={Boolean(touched.startRelaunchDate && errors.startRelaunchDate)}
                        // fullWidth
                        // helperText={touched.startRelaunchDate && errors.startRelaunchDate}
                        label="Date de début"
                        name="startDate"
                        type="date"
                        // onBlur={handleBlur}
                        onChange={handleStartDateChange}
                        value={startDate}
                        variant="outlined"
                        // pour éviter la superposition de jj/mm/aaaa et début de relance dans le champ
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <CalendarIcon color="action" fontSize="small" />
                            </InputAdornment>
                          ),
                          sx: { borderRadius: '12px', bgcolor: 'white' }
                        }}
                      />
                    </Box>
                    <Box
                      sx={{
                        m: 1
                      }}
                    >
                      <TextField
                        // error={Boolean(touched.startRelaunchDate && errors.startRelaunchDate)}
                        // fullWidth
                        // helperText={touched.startRelaunchDate && errors.startRelaunchDate}
                        label="Date de fin"
                        name="endDate"
                        type="date"
                        // onBlur={handleBlur}
                        onChange={handleEndDateChange}
                        value={endDate}
                        variant="outlined"
                        // pour éviter la superposition de jj/mm/aaaa et début de relance dans le champ
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <CalendarIcon color="action" fontSize="small" />
                            </InputAdornment>
                          ),
                          sx: { borderRadius: '12px', bgcolor: 'white' }
                        }}
                      />
                    </Box>
                    <Box
                      sx={{
                        m: 1
                      }}
                    >
                      <TextField
                        key="user"
                        label="Utilisateur"
                        name="user"
                        onChange={handleUserChange}
                        select
                        SelectProps={{ native: true }}
                        value={userSyna}
                        variant="outlined"
                        disabled={isLoading}
                  // pour éviter la superposition dans le champ
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <PersonIcon color="action" />
                            </InputAdornment>
                          ),
                          sx: { borderRadius: '12px', bgcolor: 'white' }
                        }}
                      >
                        {usersOptions.map((option) => (
                          <option
                            key={option.value}
                            value={option.value}
                          >
                            {option.label}
                          </option>
                        ))}
                      </TextField>
                    </Box>
                    <Box
                      sx={{
                        m: 1
                      }}
                    >
                      <TextField
                        key="category"
                        label="Catégorie"
                        name="category"
                        onChange={handleCategoryChange}
                        select
                        SelectProps={{ native: true }}
                        value={category}
                        variant="outlined"
                        disabled={isLoading}
                  // pour éviter la superposition dans le champ
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <CategoryIcon color="action" />
                            </InputAdornment>
                          ),
                          sx: { borderRadius: '12px', bgcolor: 'white' }
                        }}
                      >
                        {categoriesOptions.map((option) => (
                          <option
                            key={option.value}
                            value={option.value}
                          >
                            {option.label}
                          </option>
                        ))}
                      </TextField>
                    </Box>
                    <Box
                      sx={{
                        m: 1
                      }}
                    >
                      <TextField
                        key="type"
                        label="Type"
                        name="type"
                        onChange={handleTypeChange}
                        select
                        SelectProps={{ native: true }}
                        value={type}
                        variant="outlined"
                        disabled={isLoading}
                  // pour éviter la superposition dans le champ
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <LabelIcon color="action" />
                            </InputAdornment>
                          ),
                          sx: { borderRadius: '12px', bgcolor: 'white' }
                        }}
                      >
                        {typesOptions.map((option) => (
                          <option
                            key={option.value}
                            value={option.value}
                          >
                            {option.label}
                          </option>
                        ))}
                      </TextField>
                    </Box>
                    <Box
                      sx={{
                        m: 1,
                        maxWidth: '100%',
                        width: 250
                      }}
                    >
                      <Autocomplete
                        getOptionLabel={(option) => option.label}
                        options={customersOptions}
                //   disableClearable
                        onChange={(e, value) => {
                          if (value !== null) {
                            setCustomer(value.value);
                            handleLogs(sort, startDate, endDate, userSyna, category, type, value.value, limit, 0, true);
                            setCustomerAutocomplete({ value: value.value, label: value.label });
                          } else {
                            setCustomer('all');
                            handleLogs(sort, startDate, endDate, userSyna, category, type, 'all', limit, 0, true);
                          // setCustomerAutocomplete({ value: 'all', label: 'Tous' });
                          }
                          setPage(0);
                          // setSelectedCommercialToAdd(value);
                          // setFieldValue(
                          //   'choiceCommercialToAdd',
                          //   value !== null ? value : selectedCommercialToAdd
                          // );
                        }}
                        value={customerAutocomplete}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            fullWidth
                            label="Apprenant"
                            name="customer"
                            variant="outlined"
                            InputProps={{
                              ...params.InputProps,
                              sx: { borderRadius: '12px', bgcolor: 'white' }
                            }}
                          />
                        )}
                      />
                    </Box>
                  </Box>
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
                    <Button
                      onClick={reinitializeFilters}
                      color="primary"
                      variant="contained"
                      startIcon={<RefreshIcon />}
                      sx={{
                        borderRadius: '10px',
                        fontWeight: 800,
                        textTransform: 'none',
                        boxShadow: '0 4px 6px -1px rgba(99, 102, 241, 0.3)'
                      }}
                    >
                      Réinitialiser les filtres
                    </Button>
                  </Box>
                </Box>

                <StyledPaper>
                  <Scrollbar>

                    <Box sx={{ minWidth: 700 }}>
                      <Table sx={{ borderCollapse: 'separate', borderSpacing: '0 8px', minWidth: 700, px: 2 }}>
                        <TableHead>
                          <TableRow>
                            {['Utilisateur', 'Catégorie', 'Type', 'Description', 'Date'].map((head) => (
                              <TableCell key={head} sx={{ borderBottom: 'none', fontWeight: 800, color: '#64748b', textTransform: 'uppercase', fontSize: '0.75rem' }}>
                                {head}
                              </TableCell>
                            ))}
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {logs.map((log, index) =>
                          // const isCustomerSelected = selectedCustomers.includes(log.id);
                          // eslint-disable-next-line implicit-arrow-linebreak
                            (
                              <TableRow
                                component={motion.tr}
                                key={log.id}
                                initial={{ opacity: 0, y: 10 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.2, delay: index * 0.02 }}
                                sx={{
                                  backgroundColor: 'white',
                                  boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                                  transition: 'transform 0.2s, box-shadow 0.2s',
                                  '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }
                                }}
                              >
                                <TableCell sx={{ borderBottom: 'none', borderRadius: '12px 0 0 12px', fontWeight: 600, color: '#334155' }}>
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Avatar sx={{ width: 30, height: 30, bgcolor: 'rgba(99, 102, 241, 0.1)', color: 'primary.main', fontSize: '0.8rem', fontWeight: 800 }}>
                                      {log.userInfos?.firstname?.charAt(0) || 'U'}
                                    </Avatar>
                                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                      {log.userInfos.firstname} {log.userInfos.lastname}
                                    </Typography>
                                  </Box>
                                </TableCell>
                                <TableCell sx={{ borderBottom: 'none' }}>
                                  {(() => {
                                    const c = CATEGORY_STYLES[log.category];
                                    if (!c) {
                                      return <Chip label={log.category} size="small" sx={{ bgcolor: 'rgba(100,116,139,0.1)', color: '#64748b', fontWeight: 800, borderRadius: '8px' }} />;
                                    }
                                    return <Chip icon={c.icon} label={c.label} size="small" sx={{ bgcolor: c.bg, color: c.color, fontWeight: 800, borderRadius: '8px', '& .MuiChip-icon': { color: c.color } }} />;
                                  })()}
                                </TableCell>
                                <TableCell sx={{ borderBottom: 'none', fontWeight: 700, color: '#475569' }}>
                                  <Box sx={{ display: 'inline-block', px: 1, py: 0.5, bgcolor: '#f1f5f9', borderRadius: '6px', fontSize: '0.8rem' }}>
                                    {log.type.charAt(0).toUpperCase() + log.type.slice(1)}
                                  </Box>
                                </TableCell>
                                <TableCell sx={{ borderBottom: 'none', color: '#334155', maxWidth: 360, '& p': { m: 0 } }}>
                                  {/* permet d'afficher le texte de la description avec le lien cliquable arrivant de la bdd */}
                                  <div dangerouslySetInnerHTML={{ __html: log.description }} />
                                </TableCell>
                                <TableCell sx={{ borderBottom: 'none', borderRadius: '0 12px 12px 0', color: '#64748b', fontWeight: 700, fontSize: '0.8rem' }}>
                                  {moment(log.created_at).format('DD/MM/YYYY HH:mm:ss')}
                                </TableCell>
                              </TableRow>
                            ))}
                          <LimitedBackdrop
                            sx={{ color: '#fff', zIndex: (them) => them.zIndex.drawer + 1 }}
                            open={isLoading}
                          >
                            <CircularProgress color="inherit" />
                          </LimitedBackdrop>
                        </TableBody>
                      </Table>
                    </Box>
                  </Scrollbar>
                </StyledPaper>
                <TablePagination
                  component="div"
                  count={numberLogs}
                  onPageChange={handlePageChange}
                  onRowsPerPageChange={handleLimitChange}
                  page={page}
                  rowsPerPage={limit}
                  rowsPerPageOptions={[15, 25, 50]}
                  SelectProps={{
                    disabled: isLoading
                  }}
                  backIconButtonProps={
                isLoading
                  ? { disabled: isLoading } : undefined
              }
                  nextIconButtonProps={
                isLoading
                  ? { disabled: isLoading } : undefined
              }
                />
              </Card>
            </Box>
          </>
          )}
          {user.access_level !== 0 && (
            'Vous n\'avez pas les droits pour voir cette page'
          )}
        </Container>
      </Box>
    </>
  );
};

export default Logs;
